import React from 'react';
import { PAGES } from '../../site/routes';
import { SITE } from '../../data/servers';
import { usePageSeo, Breadcrumbs, PageHeader, Section } from '../../site/ui';

const BREADCRUMBS = [
  { label: 'Accueil', to: PAGES.home },
  { label: 'Politique de confidentialité', to: PAGES.privacy },
];

const Clause = ({ title, children }) => (
  <div>
    <h3 className="text-base sm:text-lg font-semibold text-white mb-1.5">{title}</h3>
    <div className="text-sm sm:text-base text-gray-400 leading-relaxed space-y-2">{children}</div>
  </div>
);

export default function PrivacyPage() {
  usePageSeo({
    title: 'Politique de confidentialité | AV Kamas',
    description: "Politique de confidentialité d'AV Kamas : données collectées, utilisation, hébergement, sécurité et vos droits sur vos données personnelles.",
    path: PAGES.privacy,
    breadcrumbs: BREADCRUMBS,
  });

  return (
    <main className="bg-gray-950 text-white">
      <Breadcrumbs items={BREADCRUMBS} />
      <PageHeader
        kicker="Légal"
        title={<>Politique de <span className="text-yellow-400">confidentialité</span></>}
        intro="Dernière mise à jour : octobre 2026. Cette page explique quelles données nous collectons et comment nous les utilisons."
      />
      <Section className="pt-0 md:pt-0">
        <div className="max-w-3xl space-y-8">
          <Clause title="1. Données collectées">
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Compte :</strong> nom, adresse email, téléphone, mot de passe (stocké chiffré, jamais en clair).</li>
              <li><strong>Commandes :</strong> serveur, quantité, montant en dirhams, nom de personnage, méthode de paiement, coordonnées bancaires (RIB pour les vendeurs).</li>
              <li><strong>Chat :</strong> messages échangés avec le support et fichiers envoyés (preuves de paiement, images, PDF).</li>
              <li><strong>Technique :</strong> journaux serveur (adresse IP, navigateur) utilisés pour la sécurité et le diagnostic.</li>
            </ul>
          </Clause>
          <Clause title="2. Utilisation des données">
            <p>
              Vos données servent uniquement à : traiter vos commandes et paiements, assurer le support via le chat,
              prévenir la fraude, et vous envoyer des notifications liées à vos commandes. Nous ne vendons ni ne louons vos
              données à des tiers.
            </p>
          </Clause>
          <Clause title="3. Cadre légal">
            <p>
              Le traitement est effectué dans le respect de la loi marocaine n° 09-08 relative à la protection des données
              personnelles. Les données sont nécessaires à l'exécution du service que vous demandez (commande, support).
            </p>
          </Clause>
          <Clause title="4. Hébergement">
            <p>
              Le site et ses données sont hébergés par OVHcloud dans un centre de données en Europe (Royaume-Uni). Les fichiers
              de preuve de paiement sont stockés de manière sécurisée sur ce serveur.
            </p>
          </Clause>
          <Clause title="5. Conservation">
            <p>
              Les comptes et commandes sont conservés tant que le compte existe et pour la durée nécessaire au suivi des
              transactions. Les messages du chat et les preuves de paiement sont conservés pour l'historique de la commande.
            </p>
          </Clause>
          <Clause title="6. Sécurité">
            <p>
              Connexion chiffrée HTTPS, mots de passe hachés, jetons de session signés, accès aux commandes protégé par jeton
              secret, validation stricte des fichiers envoyés (type et taille), et limitation des tentatives de connexion.
            </p>
          </Clause>
          <Clause title="7. Cookies et stockage local">
            <p>
              Le site utilise le stockage local de votre navigateur pour maintenir votre session, votre panier de commande et
              l'historique de chat. Aucun cookie publicitaire ou de suivi tiers n'est utilisé.
            </p>
          </Clause>
          <Clause title="8. Vos droits">
            <p>
              Vous pouvez demander l'accès, la rectification ou la suppression de vos données personnelles en nous contactant à{' '}
              <a href={`mailto:${SITE.email}`} className="text-yellow-400 hover:underline">{SITE.email}</a>. La suppression du
              compte supprime vos données personnelles, hors informations nécessaires à la justification des transactions passées.
            </p>
          </Clause>
          <Clause title="9. Contact">
            <p>
              Pour toute question relative à vos données :{' '}
              <a href={`mailto:${SITE.email}`} className="text-yellow-400 hover:underline">{SITE.email}</a>.
            </p>
          </Clause>
        </div>
      </Section>
    </main>
  );
}
